export const config = Object.freeze({
  defaultLanguage: 'en'
})
